/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable global-require */
/* eslint-disable no-undef */
/* eslint-disable import/order */
/* eslint-disable import/extensions */
/* eslint-disable no-unused-vars */
import Vue from 'vue';
import {
    getCsrfToken, CSRF_TOKEN_HEADER_NAME, doBackendRequest, KEY_USER_ID, doBackendRequestForDownload,
} from '~/assets/js/utils/auth-utils.js';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { getBranding, getBrandingVar, brandMixin } from '~/assets/js/utils/whitelabeling.js';
import ModalsGlobal from '~/components/shared/modals-global.vue';
import VTooltip from 'v-tooltip';
import runGoogleAnalytics from '~/assets/js/utils/google-analytics.js';
import sendUserDataToUserlane from '~/assets/js/utils/userlane.js';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

const PRODUCTION = 'PRODUCTION';
Vue.use(VTooltip);

VTooltip.options.autoHide = false;
VTooltip.options.defaultTemplate = '<div class="tooltipp" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';

const notAtHomepage = window.location.href.indexOf('/home') < 0;
if (AB_BUILD === PRODUCTION && notAtHomepage) {
    require('posthog-js');
    require('~/assets/js/utils/posthog.js'); // Posthog initialization
}

Vue.config.devtools = true;
dayjs.extend(relativeTime);
dayjs.extend(require('dayjs/plugin/utc'));

// set title
document.title = getBrandingVar('app_name');

// set favicon
let favicon = document.querySelector('link[rel="shortcut icon"]');
if (!favicon) {
    favicon = document.createElement('link');
    favicon.setAttribute('rel', 'shortcut icon');
    const head = document.querySelector('head');
    head.appendChild(favicon);
}

favicon.setAttribute('type', 'image');
favicon.setAttribute('href', getBrandingVar('app_icon'));

Vue.filter('niceDate', (unixdate) => {
    try {
        if (unixdate) {
            const date = dayjs.utc(unixdate * 1000).format('DD-MMM-YYYY');
            return (date === 'Invalid Date') ? unixdate : date;
        }
    } catch (err) {
        return null;
    }
    return null;
});

Vue.filter('shortDate', (unixdate) => {
    try {
        if (unixdate) {
            return dayjs.unix(unixdate).format('DD.MM.YY');
        }
    } catch (err) {
        return null;
    }
    return null;
});

Vue.filter('relativeDate', (unixdate) => {
    try {
        if (unixdate) {
            return dayjs.unix(unixdate).fromNow();
        }
    } catch (err) {
        return null;
    }
    return '-';
});

Vue.filter('niceNumber', (number) => {
    let newValue = number;
    if (number >= 1000) {
        const suffixes = ['', 'k', 'm', 'b', 't'];
        // eslint-disable-next-line prefer-template
        const suffixNum = Math.floor(('' + number).length / 3);
        let shortValue = '';
        for (let precision = 2; precision >= 1; precision--) {
            shortValue = parseFloat(
                (suffixNum !== 0
                    // eslint-disable-next-line no-restricted-properties
                    ? number / Math.pow(1000, suffixNum)
                    : value
                ).toPrecision(precision),
            );
            // eslint-disable-next-line prefer-template
            const dotLessShortValue = (shortValue + '').replace(
                /[^a-zA-Z 0-9]+/g,
                '',
            );
            if (dot_less_short_value.length <= 2) {
                break;
            }
        }
        if (shortValue % 1 !== 0) {
            shortValue = shortValue.toFixed(1);
        }
        newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
});

Vue.filter('niceDecimal', (dec) => {
    if (dec) {
        return dec.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
    return '-';
});

// eslint-disable-next-line arrow-body-style
Vue.filter('numberSeparator', (x, replacement = '') => {
    return (x || replacement).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

// function for abbreviating labels
Vue.filter('niceLabel', (label) => {
    const abbr = {
        'Commercial Services': 'Commerc. Svcs',
        'Asset Management': 'Asset Mgmt.',
        'Materials & Chemicals': 'Materials & Chems.',
        // eslint-disable-next-line quote-props
        'Hydrocarbons': 'Hydro- carbons',
        'Technology Services': 'Tech. Services',
        'Transportation & Logistics': 'Trans. & Logistics',
    };
    if (Object.keys(abbr).includes(label)) {
        return abbr[label];
    }
    return label;
});

Vue.filter('full-date', (date) => {
    try {
        if (date) {
            return dayjs(date).format('MMM DD, YY HH:mm');
        }
        return '-';
    } catch (err) { return null; }
});

Vue.filter('intlDate', (unixdate) => {
    try {
        if (unixdate) {
            return dayjs.unix(unixdate).format('DD-MMM-YYYY');
        }
    } catch (err) { return null; }
});

Vue.filter('niceBool', (bool) => {
    try {
        if (bool) {
            if (bool === 1 || bool === 0) {
                bool = Boolean(bool);
            }
            return (bool === true) ? 'Yes' : 'No';
        }
    } catch (err) { return null; }
});

Vue.filter('niceNumber', (number) => {
    let newValue = number;
    if (number >= 1000) {
        const suffixes = ['', 'k', 'm', 'b', 't'];
        // eslint-disable-next-line prefer-template
        const suffixNum = Math.floor(('' + number).length / 3);
        let shortValue = '';
        for (let precision = 2; precision >= 1; precision--) {
            shortValue = parseFloat(
                (suffixNum !== 0
                    // eslint-disable-next-line no-restricted-properties
                    ? number / Math.pow(1000, suffixNum)
                    : value
                ).toPrecision(precision),
            );
            // eslint-disable-next-line prefer-template
            const dotLessShortValue = (shortValue + '').replace(
                /[^a-zA-Z 0-9]+/g,
                '',
            );
            if (dotLessShortValue.length <= 2) {
                break;
            }
        }
        if (shortValue % 1 !== 0) {
            shortValue = shortValue.toFixed(1);
        }
        newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
});

// provides branding functionality to all components
Vue.mixin(brandMixin);

// adds global modals and the doBackendRequest function to all pages
Vue.mixin({
    components: { ModalsGlobal },
    data() {
        return {
            modalState: {
                error: false,
                success: false,
                unpaid: false,
                session_expired: false,
                warning: false,
                'risk-report': false,
                unverified: false,
            },
            error_message: '',
            success_message: '',
            session_expired_message: '',
            warning_message: '',
        };
    },
    methods: {
        updateModal(payload) {
            this.modalState[payload.key] = payload.state;
            if (payload.message) {
                this[`${payload.key}_message`] = payload.message;
            }
        },
        handleError(responseJson) {
            if (!responseJson) {
                this.updateModal({ key: 'error', state: true });
                return;
            }
            if (responseJson.error !== undefined) {
                this.error_message = responseJson.error;
                this.updateModal({ key: 'error', state: true });
            }
            if (responseJson.subscription_needed === true) {
                this.updateModal({ key: 'unpaid', state: true });
            }
        },
        doBackendRequest(method, path, successCallback, payload, failureCallback) {
            const self = this;
            // if fromLocal and fromSession and fromLocal.user_id !== fromSession.user_id: go to /login or show error saying session expired popup
            if (sessionStorage.getItem(KEY_USER_ID) && localStorage.getItem(KEY_USER_ID) && (sessionStorage.getItem(KEY_USER_ID) !== localStorage.getItem(KEY_USER_ID))) {
                self.handleError({ error: 'A different user was logged in, please close this tab.' });
                failureCallback();
            } else {
                doBackendRequest(method, path, successCallback, payload, (responseJson) => {
                    if (!responseJson) {
                        if (failureCallback) {
                            failureCallback(responseJson);
                        } else {
                            self.handleError(responseJson);
                        }
                    } else if (responseJson.redirect && responseJson.redirect !== undefined) {
                        if (responseJson.redirect.indexOf('login') >= 0) {
                            const url = new URL(responseJson.redirect, window.location.origin);
                            url.searchParams.set('redirect_url', `${window.location.pathname}${window.location.search}`);
                            // eslint-disable-next-line no-param-reassign
                            responseJson.redirect = url.href;
                        }
                        document.location.href = responseJson.redirect;
                    } else if (responseJson.session_expired && responseJson.session_expired !== undefined) {
                        document.location.href = `/login?session_expired=true&redirect_url=${window.location.pathname}${window.location.search}`;
                    } else if (failureCallback) {
                        failureCallback(responseJson);
                    } else {
                        self.handleError(responseJson);
                    }
                });
            }
        },
        doBackendRequestForDownload(method, path, successCallback, payload, failureCallback) {
            doBackendRequestForDownload(method, path, successCallback, payload, failureCallback);
        },
        doBackendRequestAsync(method, path, payload) {
            return new Promise((resolve, reject) => {
                const failureCallback = (response) => {
                    reject(response);
                };
                const successCallback = (response) => {
                    resolve(response);
                };

                this.doBackendRequest(method, path, successCallback, payload, failureCallback);
            });
        },
        emptyLocalStorage() {
            localStorage.removeItem('KEY_USER_ID');
            localStorage.removeItem('KEY_REQUESTED_ACCOUNT_ID');
            localStorage.removeItem('KEY_ACCESSIBLE_ACCOUNTS');
        },
        matchMultipleRegex(regexList, word) {
            const foundMatches = [];
            regexList.forEach((regex) => {
                const foundMatch = word.match(regex);
                if (foundMatch) foundMatches.push(foundMatch);
            });
            return foundMatches.length === regexList.length;
        },
    },
});

runGoogleAnalytics(doBackendRequest);

if (AB_BUILD === PRODUCTION) {
    sendUserDataToUserlane();
}

const footer = document.querySelector('.support-footer');
if (footer) {
    const intro = 'For technical support, please contact us at';
    let branding = getBranding();
    if (branding === 'autobahn') {
        // eslint-disable-next-line no-const-assign
        branding = '';
    }
    const address = `${getBrandingVar('mail_support_local')}@${getBrandingVar('mail_domain')}`;
    const f = `${intro}: <a class="text-${branding}-primary" href="mailto: ${address}">${address}</a>`;
    footer.innerHTML = f;
}

Vue.directive('click-outside', {
    // eslint-disable-next-line object-shorthand
    bind: function (el, binding) {
        const handler = function (e) {
            if (!el.contains(e.target) && el !== e.target) {
                binding.value(e);
            }
        };
        // eslint-disable-next-line no-underscore-dangle
        el.__vueClickOutside__ = handler;
        document.addEventListener('click', handler);
    },
    // eslint-disable-next-line object-shorthand
    unbind: function (el, binding) {
        // eslint-disable-next-line no-underscore-dangle
        document.removeEventListener('click', el.__vueClickOutside__);
        // eslint-disable-next-line no-underscore-dangle
        el.__vueClickOutside__ = null;
    },
});

// extensions
Math.roundWithDecimal = function roundWithDecimal(number, decimal = 2) {
    // eslint-disable-next-line no-restricted-properties
    const multiplier = Math.pow(10, decimal);
    return Math.round((number + Number.EPSILON) * multiplier) / multiplier;
};

if (AB_BUILD === 'PRODUCTION') {
    Sentry.init({
        Vue,
        dsn: 'https://ec050f3635164c6386b6217ed1d2e5d3@o1071927.ingest.sentry.io/6069807',
        tracesSampleRate: 1.0,
        integrations: [new Integrations.BrowserTracing()],
        trackComponents: true,
    });
}
